import React, { Component } from 'react'
import { connect } from 'react-redux'

import { selectProject } from '../../actions'
import ProjectSettingsGeneral from '../ProjectSettings/ProjectSettingsGeneral'

import { Modal } from 'antd'

class ProjectModal extends Component {
  render () {
    const { nav, projects, selectProject } = this.props

    const currentProject = projects && nav.project && projects[nav.project.id]

    return (
      <Modal visible={nav.project && true} onCancel={() => selectProject(null)} footer={null}>
        {nav.project && <ProjectSettingsGeneral project={currentProject} />}
      </Modal>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  nav: state.nav,
  projects: state.projects
})

const mapDispatchToParams = {
  selectProject
}

export default connect(mapStateToProps, mapDispatchToParams)(ProjectModal)



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectModal.js